import {Component} from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import ConfigFile from '../../datasets/config_file';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import buildUrl from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    creditCardInfo: state.creditCardInfo,
    gameData: state.gameData
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};

class TestActivities extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            previousProcess:  "",
            allCompleteText: "",
            processingCompleteSw: false,
            totalNbrGameMonths: ConfigFile.gameStartItems.totalNbrGameMonths,
            creditCardLoaded: false,
            headers: setHeadersForFetch(),
            environment: Config.dataURL.currentEnv,
        }
         
    }

    goToActivities(activityName){
        const activityCategory = {detail: activityName, totalNbrGameMonths: this.props.totalNbrGameMonths};
        this.props.setInfoRedux(activityCategory, "activityCategory")
        this.props.onNavigate("select-activity");
    }
   
  
    render() {
       
    return <>
        <div className="col-8">
        <div className="card mt-3 rounded-corners-lg text-center game-board"
            style={{backgroundImage: `url(${process.env.PUBLIC_URL + this.state.backgroundURL})`}}>
            <h3 className="mt-2 text-center">Special Processes</h3>
            <h5 className="text-center">Test Activities</h5>
            {!this.state.creditCardLoaded   ?
                <WaitTimeSpinner/>
            :
                <span className="mt-2 ml-4 mr-4">
                    <div className="my-2">
                        <Button variant="primary"  onClick={() => this.goToActivities("SideHustle")}>
                        SideHustle
                        </Button>
                    </div>
                    <div className="my-4">
                        <Button variant="primary"  onClick={() => this.goToActivities("Volunteer")}>
                        Volunteer
                        </Button>
                    </div>
                    <div className="my-4">
                        <Button variant="primary"  onClick={() => this.goToActivities("HaveFun")}>
                        HaveFun
                        </Button>
                    </div>
                    <div className="my-4">
                        <Button variant="primary"  onClick={() => this.goToActivities("Vacation")}>
                        Vacation
                        </Button>
                    </div>
                </span>
            }
           </div>        
        </div>
     </>
    }

    componentDidMount(){
        this._isMounted = true;
        const creditCardInfo = this.props.creditCardInfo;
        if (!creditCardInfo.game_ID){
            this.loadCreditCard();
        }else{
            if (this._isMounted === true){
                this.setState({creditCardLoaded: true});
            }
        }
    }

        loadCreditCard(){
            const gameData = this.props.gameData;
            const gameID = gameData._id;
            const funcName = "loadCreditCardInfo";
            const urlParm = "?gameID=" + gameID;
            const uri = buildUrl(this.state.environment, funcName, urlParm);
            fetch (uri, 
                { method: 'GET', headers: this.state.headers })
                .then(response => {
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            let creditCard = output.body;
                            this.props.setInfoRedux(creditCard, "creditCardInfo")
                            if (this._isMounted === true){
                                this.setState({creditCardLoaded: true});
                            }
                        }else{
                            if (statusCode === 250){
                                 // there is no credit card record for this player
                                 this.setState({creditCardLoaded: true});
                            }else{
                                const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                                this.processErrorReturn(errorObj);
                            }
                        }
                    });
                });
        }
}


export default connect(mapStateToProps, mapDispatchToProps)(TestActivities);